import Vue from "vue";
import Vuex from "vuex";
import mutations from "./store/mutations";
import createPersistedState from "vuex-persistedstate";
import initState from "./store/initState";

Vue.use(Vuex);
const plugins = [createPersistedState({
  key: "avocadox"
})];

export default new Vuex.Store({
  state: initState(),
  mutations,
  plugins,
});
